import { Hooks } from 'providers';
import React, {
  LegacyRef,
  MouseEvent,
  MutableRefObject,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import DeleteBoard from 'components/layouts/modal/DeleteBoard';

import { checkIsAdmin } from 'helpers/checkIsAdmin';
import { useOuterClick } from 'providers/OutsideClick';

import { HIT_RESET } from 'redux/actions/auth';
import {
  VALIDATION_COMPANY,
  VALIDATION_DASHBOARD,
} from 'redux/actions/validationRole';

import Button from 'components/_parts/atoms/button';
import IconCustom from 'components/_parts/atoms/icon';
import { BoardTypes } from 'components/types/boardList';
import moment from 'helpers/dayjsWrapper';
import { HIT_LIST_MEMBER } from 'redux/actions/company';
import { useDuplicateBoard } from '../api/useBoard';

type Props = {
  setModalAdd: (e: boolean) => void;
  setModalInfo: (e: boolean) => void;
  setDataInfo: (e: {}) => void;
  getPosition: (e: MouseEvent) => void;
  listBoard: BoardTypes[]
};

type HooksType = {
  setModalDelete: (e: boolean) => void;
  keywordBoard: string;
  setBoardNow: (e: string) => void;
  setModal: (e: boolean) => void;
};

function CardBoardComponent(props: Readonly<Props>) {
  const {
    listBoard, setDataInfo, setModalAdd, setModalInfo, getPosition,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    setModalDelete,
    keywordBoard,
    setBoardNow,
    setModal,
  } : HooksType = useContext(Hooks);
  const [activeBoard, setActiveBoard] = useState('');

  const { mutate: duplicateBoard } = useDuplicateBoard();

  const innerRef: MutableRefObject<undefined> = useOuterClick(() => {
    if (activeBoard) {
      setActiveBoard('');
    }
  });
  useEffect(() => {
    dispatch({
      type: VALIDATION_COMPANY,
    });
  }, []);

  const labelBoard = useCallback((item: string) => {
    if (item === 'Private') {
      return t('board.private');
    }
    return t('board.public');
  }, [t]);

  const hideBoard = (name: string, error: boolean) => {
    const missmatchKeyword = keywordBoard !== undefined && !name?.toLowerCase().includes(keywordBoard?.toLowerCase());

    return missmatchKeyword || error;
  };

  const isAdmin = (val) => checkIsAdmin(val.validation_member?.user_type);

  return (
    <>
      <DeleteBoard for="board" />
      {listBoard.map((val, x) => (
        <div
          key={val.board_id}
          className={`col-lg-6 col-xl-4 d-flex test ${hideBoard(val.name, val.validation_member?.error) ? 'rBoardHide' : ''}`}
          style={{ maxHeight: '190px', height: '100%' }}
        >
          <div
            className="card flex-fill rCard shadowMonitor"
          >
            <div className="card-header pb-1">
              <div
                className="card-actions float-right d-flex justify-content-center"
                style={{ gap: '8px' }}
              >
                <button
                  type="button"
                  className="btn btn-pill btn-sm pointerOff"
                  style={{
                    backgroundColor: '#9AFF5B',
                    color: '#FFFF',
                    fontSize: '10px',
                  }}
                >
                  {labelBoard(val.visibility_status_ket)}
                </button>

                <div
                  aria-hidden="true"
                  className="dropdown"
                  style={{
                    cursor: !isAdmin(val) ? 'not-allowed' : 'pointer',
                    pointerEvents: !isAdmin(val) ? 'none' : 'auto',
                  }}
                  onClick={() => {
                    setActiveBoard(val.board_id);
                  }}
                >
                  <IconCustom
                    typeIcon="setting"
                    style={{
                      stroke: !isAdmin(val) ? '#b7b7b7' : '#000',
                    }}
                  />
                  <div
                    ref={innerRef as unknown as LegacyRef<HTMLDivElement>}
                    className={`dropdown-menu dropdown-menu-right board-p ${activeBoard === val.board_id ? 'show' : ''}`}
                  >
                    <button
                      type="button"
                      className="dropdown-item"
                      onClick={() => {
                        dispatch({
                          type: HIT_LIST_MEMBER,
                        });
                        dispatch({
                          type: VALIDATION_DASHBOARD,
                          payload: {
                            board_id: val.board_id,
                          },
                          types: 'dashboard',
                        });
                        localStorage.setItem('board_id', val.board_id);
                        setModalInfo(true);
                        setDataInfo(val);
                      }}
                    >
                      <IconCustom
                        typeIcon="information"
                      />
                      {t('board.info')}
                    </button>
                    <button
                      type="button"
                      className={`dropdown-item ${
                        !isAdmin(val) ? 'd-none' : ''
                      }`}
                      onClick={() => {
                        duplicateBoard({
                          board_id: val.board_id,
                          publish_status: '0',
                        });
                      }}
                    >
                      <IconCustom
                        typeIcon="duplicate"
                      />
                      {t('board.duplicate')}
                    </button>
                    <div className="dropdown-divider" />
                    <button
                      type="button"
                      className={`dropdown-item ${
                        !isAdmin(val) ? 'd-none' : ''
                      }`}
                      onClick={() => {
                        setModalDelete(true);
                        setModal(true);
                        setBoardNow(val.board_id);
                      }}
                      data-toggle="modal"
                      data-target="#deleteModal"
                    >
                      <IconCustom
                        typeIcon="delete2"
                      />
                      {t('board.delete')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="list-board"
              aria-hidden="true"
              className="card-body px-4 py-2"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                dispatch({
                  type: HIT_RESET,
                });
                dispatch({
                  type: VALIDATION_DASHBOARD,
                  payload: {
                    board_id: val.board_id,
                  },
                  types: 'dashboard',
                });
                history.push('/dashboard');
                localStorage.setItem('board_id', val.board_id);
                localStorage.setItem('board_name', val.name);
                localStorage.setItem('board_index', String(x));
              }}
            >
              <div className="row d-flex align-items-center">
                <div className="col-12">
                  <p
                    className="align-items-center rStructureTitle mb-0"
                    dangerouslySetInnerHTML={{
                      __html: val.name,
                    }}
                    style={{
                      fontSize: '14px',
                      fontWeight: '800',
                      lineHeight: '14px',
                      maxWidth: '90%',
                      padding: '1px 0px',
                    }}
                  />
                  {/* </a> */}
                  {val.description !== '' && (
                  <div
                    id="textDetailJobdesc"
                    className="rCardShortdesc mt-1 mb-0 lineClamp3"
                    dangerouslySetInnerHTML={{
                      __html: val.description || '.',
                    }}
                  />
                  )}
                </div>
              </div>
            </div>
            {/* </Link> */}

            <div className="card-footer pt-0" style={{ alignSelf: 'normal' }}>
              <p className="textMonitorning mb-0">
                {t('board.last_update')}
                {' '}
                <span style={{ fontWeight: '800' }}>
                  {moment(val.last_update).local().format('DD MMM YYYY')}
                </span>
              </p>
            </div>
          </div>
        </div>
      ))}
      <div className="col-lg-6 col-xl-4 d-flex">
        <div
          className="card flex-fill addCard"
          style={{ maxHeight: '160px' }}
        >
          <div className="card-body d-flex align-items-center justify-content-center">
            <div
              aria-hidden="true"
              className="col-12"
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                setModalAdd(true);
                getPosition(e);
              }}
            >
              <p
                className="textAddCard mb-4"
                data-toggle="modal"
                data-target="#addBoardModal"
              >
                {t('board.create')}
              </p>

              <Button
                style={{
                  width: '28px',
                  height: '28px',
                  background: '#9AFF5B',
                  margin: 'auto',
                }}
                icon="create"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const CardBoard = React.memo(CardBoardComponent);
export default CardBoard;

export const publishStat = (val: number) => {
  switch (val) {
    case 0:
      return 'Draft';

    case 1:
      return 'Review';

    case 2:
      return 'Accepted';

    case 3:
      return 'Archived';

    default:
      return 'Draft';
  }
};
